module.exports = __webpack_public_path__ + "img/pdf1.e4c59688.png";